import { AccountModel, fetchRoute, getBrandUrl, TBrand, UserModel } from "@cakemail-org/ui-components-v2"
import { hasFeatureFlag, EFeatureFlags } from "./limits_features"
import { ERoutes } from "./url"
import { openSupportDialog } from "../components/dialogs/supportDialog"
import { t } from "i18next"

export function goToBilling({ account, user, brand }: { account: AccountModel, user: UserModel, brand: TBrand }) {

    if (!hasAccessToBilling({ account, brand })) {
        return
    }

    const stripeAccess = hasFeatureFlag({ flag: EFeatureFlags.stripePortal, partnerBrand: brand })
    const billingPlanURL = getBrandUrl({
        mainKey: "url",
        elKey: "plan_upgrade",
        brand: brand,
        locale: user.language
    })

    if (stripeAccess) {
        window.location.href = "#" + fetchRoute({ route: ERoutes.billing })
    }
    else if (billingPlanURL) {
        window.location.href = billingPlanURL
    } else {
        openSupportDialog({
            dialogContent: t("manage-plan-dialog-desc"),
            dialogTitle: t("general-manage-plan"),
            request: {
                type: "support",
                subject: "I want to manage my account plan",
                message: "I want to manage my account plan."
            }
        })
    }
}

export function hasAccessToBilling({ account, brand }: { account: AccountModel, brand: TBrand }) {
    if (account.isPartnerOrOrganization() ||
        !hasFeatureFlag({ flag: EFeatureFlags.stripePortal, partnerBrand: brand })
    ) {
        return false
    }

    return true
}